module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('global-layout', [_c('contextmenu', {
    attrs: {
      "itemList": _vm.menuItemList,
      "visible": _vm.menuVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.menuVisible = $event
      },
      "select": _vm.onMenuSelect
    }
  }), _vm._v(" "), (_vm.multipage) ? _c('a-tabs', {
    staticClass: "page-tabs",
    staticStyle: {
      "margin-top": "-10px",
      "margin-bottom": "-2px",
      "border": "0px"
    },
    attrs: {
      "active-key": _vm.activePage,
      "hide-add": true,
      "type": "editable-card"
    },
    on: {
      "change": _vm.changePage,
      "edit": _vm.editPage
    },
    nativeOn: {
      "contextmenu": function($event) {
        return (function (e) { return _vm.onContextmenu(e); }).apply(null, arguments)
      }
    }
  }, _vm._l((_vm.pageList), function(page) {
    return _c('a-tab-pane', {
      key: page.fullPath,
      attrs: {
        "id": page.fullPath,
        "closable": page.meta.closeable,
        "forceRender": ""
      }
    }, [_c('span', {
      attrs: {
        "slot": "tab",
        "pagekey": page.fullPath
      },
      slot: "tab"
    }, [_vm._v(_vm._s(page.name))])])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.multipage) ? _c('keep-alive', [_c('router-view', {
    key: _vm.$route.path
  })], 1) : _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-178376b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/MenuView.vue
// module id = PFvt
// module chunks = 273